module.exports = __webpack_public_path__ + "static/media/arrow-right-circle.3deb5de9.png";